/**
 * SidebarLink — lien de navigation latérale pour les espaces authentifiés.
 * État actif : pill noir avec ombre dure tomate (signature PASSAGE).
 * État inactif : texte ink, hover cream.
 *
 * Utilisé par EtudiantLayout, EntrepriseLayout, ResponsableLayout, AdminLayout.
 */
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

export interface SidebarLinkProps {
  to: string;
  end?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

export function SidebarLink({ to, end, disabled, children }: SidebarLinkProps) {
  if (disabled) {
    return (
      <span
        aria-disabled="true"
        className="block rounded-xl px-3 py-2 text-sm font-semibold text-passage-ink-soft/60"
      >
        {children}
      </span>
    );
  }
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'block rounded-xl px-3 py-2 text-sm font-semibold transition',
          isActive
            ? 'border-2 border-passage-ink bg-passage-ink text-white shadow-[3px_3px_0_#E63946]'
            : 'border-2 border-transparent text-passage-ink hover:border-passage-ink hover:bg-passage-cream',
        )
      }
    >
      {children}
    </NavLink>
  );
}
